angular.module('umCore')
    .constant('notificationConstant', {
        email: {
            NONE: '<notification><email/><emailOption>NONE</emailOption></notification>'
        }
    });
